var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LinkListItem, getTestId } from '@airtel/air-design-system';
import { useEffect, useRef } from 'react';
export var LinkListItemWidgetComponent = props => {
  var id = props.id,
    onUserAction = props.onUserAction,
    _onPress = props.onPress,
    _props$enableScroll = props.enableScroll,
    enableScroll = _props$enableScroll === void 0 ? false : _props$enableScroll,
    scrollMetaData = props.scrollMetaData,
    actionTypeOnPressMetaData = props.actionTypeOnPressMetaData,
    metaInfoCtaPressMetaData = props.metaInfoCtaPressMetaData,
    infoIconPressMetaData = props.infoIconPressMetaData,
    onRefreshCtaTimerCompleteMetaData = props.onRefreshCtaTimerCompleteMetaData,
    onInvisibleItemMountMetaData = props.onInvisibleItemMountMetaData,
    _props$showTooltip = props.showTooltip,
    showTooltip = _props$showTooltip === void 0 ? false : _props$showTooltip,
    _props$tooltipProps = props.tooltipProps,
    tooltipProps = _props$tooltipProps === void 0 ? {} : _props$tooltipProps,
    testID = props.testID,
    _props$isCurrentItemV = props.isCurrentItemVisible,
    isCurrentItemVisible = _props$isCurrentItemV === void 0 ? true : _props$isCurrentItemV,
    onPressHandler = props.onPressHandler,
    actionTypeOnPressHandler = props.actionTypeOnPressHandler,
    metaInfoCtaPressHandler = props.metaInfoCtaPressHandler,
    infoIconPressHandler = props.infoIconPressHandler,
    onRefreshCtaTimerCompleteHandler = props.onRefreshCtaTimerCompleteHandler,
    onMountHandler = props.onMountHandler,
    restProps = __rest(props, ["id", "onUserAction", "onPress", "enableScroll", "scrollMetaData", "actionTypeOnPressMetaData", "metaInfoCtaPressMetaData", "infoIconPressMetaData", "onRefreshCtaTimerCompleteMetaData", "onInvisibleItemMountMetaData", "showTooltip", "tooltipProps", "testID", "isCurrentItemVisible", "onPressHandler", "actionTypeOnPressHandler", "metaInfoCtaPressHandler", "infoIconPressHandler", "onRefreshCtaTimerCompleteHandler", "onMountHandler"]);
  var viewRef = useRef(null);
  var handleScrolling = () => {
    setTimeout(() => {
      viewRef.current.measure((_, __, ___, ____, _____, pageY) => {
        scrollMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, scrollMetaData), Object.assign(Object.assign({}, props), {
          position: pageY
        })));
      });
    }, 500);
  };
  useEffect(() => {
    onMountHandler === null || onMountHandler === void 0 ? void 0 : onMountHandler();
  }, []);
  useEffect(() => {
    if (enableScroll) {
      if (!isCurrentItemVisible) {
        onInvisibleItemMountMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onInvisibleItemMountMetaData), Object.assign({}, props)));
      } else {
        handleScrolling();
      }
    }
  }, [enableScroll]);
  useEffect(() => {
    if (isCurrentItemVisible && enableScroll && viewRef.current) {
      handleScrolling();
    }
  }, [isCurrentItemVisible]);
  return _jsx(LinkListItem, Object.assign({}, restProps, getTestId(testID), {
    ref: viewRef,
    onPress: () => {
      onPressHandler === null || onPressHandler === void 0 ? void 0 : onPressHandler();
      _onPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, _onPress), props));
    },
    actionTypeOnPress: data => {
      var _a;
      actionTypeOnPressHandler === null || actionTypeOnPressHandler === void 0 ? void 0 : actionTypeOnPressHandler();
      (_a = props === null || props === void 0 ? void 0 : props.actionTypeOnPress) === null || _a === void 0 ? void 0 : _a.call(props, props);
      actionTypeOnPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, actionTypeOnPressMetaData), Object.assign(Object.assign({}, props), {
        checked: data === null || data === void 0 ? void 0 : data.checked
      })));
    },
    metaInfoCtaPress: () => {
      metaInfoCtaPressHandler === null || metaInfoCtaPressHandler === void 0 ? void 0 : metaInfoCtaPressHandler();
      metaInfoCtaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, metaInfoCtaPressMetaData), props));
    },
    showInfoIcon: showTooltip,
    infoIconTooltipProps: tooltipProps,
    infoIconPress: () => {
      infoIconPressHandler === null || infoIconPressHandler === void 0 ? void 0 : infoIconPressHandler();
      infoIconPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, infoIconPressMetaData), props));
    },
    onRefreshCtaTimerComplete: () => {
      onRefreshCtaTimerCompleteHandler === null || onRefreshCtaTimerCompleteHandler === void 0 ? void 0 : onRefreshCtaTimerCompleteHandler();
      onRefreshCtaTimerCompleteMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, infoIconPressMetaData), props));
    }
  }));
};
LinkListItemWidgetComponent.genericRendererKey = 'AirLinkListItemWidget';